<template>
  <div
    class="brands-icons-container w-100 d-flex align-items-center"
    :class="{ inline: inlineDesktop }"
  >
    <div v-for="(brand, index) in brands" :key="index" class="icon-box" :style="imgPadding">
      <img
        :src="brand.src"
        :alt="brand.alt"
        :width="brand.scaledWidth"
        :height="brand.scaledHeight"
        :style="styles"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandsBlock',
  props: {
    brands: {
      type: Array,
      required: true
    },
    height: {
      type: Number,
      required: false,
      default: 0
    },
    padding: {
      type: Number,
      required: false,
      default: 25
    },
    inlineDesktop: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    styles() {
      return this.height ? `height: ${this.height}px; width: auto;` : '';
    },
    imgPadding() {
      return `padding: ${this.padding}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
.brands-icons-container {
  flex-flow: wrap;
  justify-content: space-between;
  &.inline {
    @include min-lg {
      flex-flow: nowrap;
    }
  }
  .icon-box {
    margin: auto;
    img {
      max-width: 150px;
      max-height: 80px;
      filter: brightness(1);
      width: 100%;
    }
  }
}
</style>
